import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Modal,
} from "@mui/material";
import Image from "./fondo4.jpg";
import { PreciosContext } from "../hooks/PricesContext";
import DonutChart2 from "./Chart2";
import PortfolioComponent from "./PortfolioComponent";
import Tooltip from "@mui/material/Tooltip";

const myStyle = {
  backgroundColor: "#CCCCCC",
  height: "100%",
  minHeight: "90vh",
  marginTop: "0px",
  width: "100%",
};

const opciones = [
  { ticker: "AAPL", nombre: "Apple Inc." },
  { ticker: "ABT", nombre: "Abbot Laboratories" },
  { ticker: "ADBE", nombre: "Adobe" },
  { ticker: "AMD", nombre: "AMD" },
  { ticker: "AMZN", nombre: "Amazon.com Inc." },
  { ticker: "AXP", nombre: "American Express" },
  { ticker: "AZN", nombre: "AztraZeneca" },
  { ticker: "BA", nombre: "Boeing" },
  { ticker: "BABA", nombre: "Alibaba" },
  { ticker: "BAC", nombre: "Bank of America" },
  { ticker: "BIIB", nombre: "Biogen Inc." },
  // { ticker: "BRK.B", nombre: "Berkshire Hathaway" },
  { ticker: "CVX", nombre: "Chevron" },
  { ticker: "DE", nombre: "Deere & Company" },
  { ticker: "DIS", nombre: "Disney" },
  { ticker: "GE", nombre: "General Electric" },
  { ticker: "GLOB", nombre: "Globant" },
  { ticker: "GOLD", nombre: "Barrick Gold" },
  { ticker: "GOOG", nombre: "Alphabet Inc." },
  { ticker: "HAL", nombre: "Halliburton" },
  { ticker: "HPQ", nombre: "HP Inc." },
  { ticker: "INTC", nombre: "Intel" },
  { ticker: "JNJ", nombre: "Johnson & Johnson" },
  { ticker: "JPM", nombre: "JPMorgan" },
  { ticker: "KO", nombre: "Coca-Cola" },
  { ticker: "LMT", nombre: "Lockheed Martin" },
  { ticker: "MCD", nombre: "McDonald's" },
  { ticker: "MELI", nombre: "Mercado Libre" },
  { ticker: "META", nombre: "Meta Platforms" },
  { ticker: "MMM", nombre: "3M Company" },
  { ticker: "MSFT", nombre: "Microsoft" },
  { ticker: "NKE", nombre: "NIKE" },
  { ticker: "NFLX", nombre: "Netflix" },
  { ticker: "NVDA", nombre: "Nvidia" },
  { ticker: "PEP", nombre: "PepsiCo" },
  { ticker: "PG", nombre: "Procter & Gamble" },
  { ticker: "PYPL", nombre: "PayPal" },
  { ticker: "SBUX", nombre: "Starbucks" },
  { ticker: "T", nombre: "AT&T" },
  { ticker: "TS", nombre: "Tenaris" },
  { ticker: "TSLA", nombre: "Tesla" },
  { ticker: "UBER", nombre: "Uber Technologies" },
  { ticker: "UNH", nombre: "UnitedHealth Group" },
  { ticker: "V", nombre: "Visa" },
  { ticker: "VIST", nombre: "Vista O&G" },
  { ticker: "VZ", nombre: "Verizon" },
  { ticker: "WFC", nombre: "Wells Fargo" },
  { ticker: "WMT", nombre: "Walmart" },
  { ticker: "XOM", nombre: "Exxon Mobil" },
];

const MiPortfolio = () => {
  const { stocks, dolarCCL } = useContext(PreciosContext);
  const [acciones, setAcciones] = useState([]);
  const [formData, setFormData] = useState({
    ticker: "",
    cantidad: "",
  });

  const [chartData, setChartData] = useState([]);

  const [open, setOpen] = useState(false);
  const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);

  const handleOpen = (perfil) => {
    setPerfilSeleccionado(perfil);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    actualizarChartData();
  }, [acciones]);

  const actualizarChartData = () => {
    const newData = acciones.map((accion) => ({
      name: accion.ticker,
      value: valorAccion(accion.ticker, accion.cantidad),
    }));
    setChartData(newData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validar el ticker: solo entre 1 y 5 letras
    if (formData.ticker.length >= 1 && formData.ticker.length <= 5) {
      // Verificar si ya existe una acción con el mismo ticker
      const existingIndex = acciones.findIndex(
        (acc) => acc.ticker === formData.ticker
      );
      if (existingIndex !== -1) {
        // Si ya existe, sumar la cantidad a la acción existente
        const nuevasAcciones = [...acciones];
        nuevasAcciones[existingIndex].cantidad += parseInt(
          formData.cantidad,
          10
        ); // Convertir a número
        setAcciones(nuevasAcciones);
      } else {
        // Si no existe, agregar la acción al estado de acciones
        setAcciones([
          ...acciones,
          { ...formData, cantidad: parseInt(formData.cantidad, 10) },
        ]); // Convertir a número
      }
      // Limpiar el formulario
      setFormData({ ticker: "", cantidad: "" });
    } else {
      alert("El ticker debe tener entre 1 y 5 letras.");
    }
  };

  const calculoPerAccion = (ticker) => {
    const stock = stocks.find((stock) => stock.ticker === ticker);
    return (stock.price * stock.Acciones) / stock.NetIncome;
  };

  // const calculoEVtoFCFAccion = (ticker) => {
  //   const stock = stocks.find(stock => stock.ticker === ticker);
  //   if (stock.category === "Financiero") {
  //     return ((stock.price * stock.Acciones) / stock.NetIncome)
  //   } else {
  //     return (((stock.price * stock.Acciones) + stock.Debt - stock.CashandEquiv) / (stock.NetIncome + stock.DandA - stock.CAPEX));
  //   }
  // }

  const calculoEVtoFCFAccion = (ticker) => {
    const stock = stocks.find((stock) => stock.ticker === ticker);
    if (stock.category === "Financiero") {
      return (stock.price * stock.Acciones) / stock.NetIncome;
    } else {
      const FCF = stock.NetIncome + stock.DandA - stock.CAPEX;
      if (FCF < 0) {
        // Manejar FCF negativo (por ejemplo, asignar un valor predeterminado)
        return 100; // O cualquier otro valor predeterminado que consideres adecuado
      } else {
        return (
          (stock.price * stock.Acciones + stock.Debt - stock.CashandEquiv) / FCF
        );
      }
    }
  };

  const calculoPerCartera = (acciones) => {
    let perPonderado = 0;
    acciones.forEach((accion) => {
      const stock = stocks.find((stock) => stock.ticker === accion.ticker);
      if (stock) {
        const per = calculoPerAccion(stock.ticker);
        perPonderado +=
          (per *
            calcularPorcentaje(
              accion.cantidad,
              accion.ticker,
              calcularValorTotal("ARS")
            )) /
          100;
      }
    });
    return perPonderado;
  };

  const calculoEVtoFCFCartera = (acciones) => {
    let fcfPonderado = 0;
    acciones.forEach((accion) => {
      const stock = stocks.find((stock) => stock.ticker === accion.ticker);
      if (stock) {
        const fcf = calculoEVtoFCFAccion(stock.ticker);
        fcfPonderado +=
          (fcf *
            calcularPorcentaje(
              accion.cantidad,
              accion.ticker,
              calcularValorTotal("ARS")
            )) /
          100;
      }
    });
    return fcfPonderado;
  };

  const handleEliminarAccion = (index) => {
    const nuevasAcciones = [...acciones];
    nuevasAcciones.splice(index, 1);
    setAcciones(nuevasAcciones);
  };

  const handleConfirmar = () => {
    console.log(acciones);
    const codigoIdentificador = generarCodigoIdentificador(acciones);
    console.log("Código Identificador del Portfolio:", codigoIdentificador);
  };

  const calcularValorTotal = (a) => {
    let valorTotalUSD = 0;
    let valorTotalARS = 0;
    acciones.forEach((accion) => {
      const stock = stocks.find((stock) => stock.ticker === accion.ticker);
      if (stock) {
        valorTotalUSD += (accion.cantidad * stock.price) / stock.ratio;
        valorTotalARS += ((accion.cantidad * stock.price) / stock.ratio) * (dolarCCL || 1100);
      }
    });
    if (a === "USD") {
      return valorTotalUSD;
    } else if (a === "ARS") {
      return valorTotalARS;
    }
  };

  const valorAccion = (ticker, cantidad) => {
    const stock = stocks.find((stock) => stock.ticker === ticker);
    const precioARSRatio = (stock.price / stock.ratio) * (dolarCCL || 1100);
    const valorAccion = cantidad * precioARSRatio;
    return valorAccion;
  };

  const valorAccionUSD = (ticker, cantidad) => {
    const stock = stocks.find((stock) => stock.ticker === ticker);
    const precioARSRatio = stock.price / stock.ratio;
    const valorAccion = cantidad * precioARSRatio;
    return valorAccion;
  };

  const calcularPorcentaje = (cantidad, ticker, valorTotal) => {
    const valorAcciones = valorAccion(ticker, cantidad);
    return ((valorAcciones / valorTotal) * 100).toFixed(2);
  };

  const generarCodigoIdentificador = (acciones) => {
    let codigo = "";
    acciones.forEach((accion, index) => {
      codigo += `${accion.cantidad}${accion.ticker}`;
    });
    return codigo;
  };

  const [codigoPortfolio, setCodigoPortfolio] = useState("");

  const generarPortfolio = ({ codigoPortfolio }) => {
    const regex = /(\d+)([A-Za-z.]+)/g; // Modificamos la expresión regular para incluir el punto como un carácter válido en el ticker
    const nuevasAcciones = [];

    let match;
    while ((match = regex.exec(codigoPortfolio)) !== null) {
      const cantidad = parseInt(match[1], 10);
      const ticker = match[2];
      nuevasAcciones.push({ ticker, cantidad });
    }

    return nuevasAcciones; // Devuelve las acciones generadas
  };

  const handleChangeCodigoPortfolio = (event) => {
    setCodigoPortfolio(event.target.value);
  };

  const handleSubmitCodigoPortfolio = () => {
    const nuevasAcciones = generarPortfolio({ codigoPortfolio }); // Llama a generarPortfolio con el código ingresado
    setAcciones(nuevasAcciones); // Actualiza el estado de acciones con las acciones generadas
    setCodigoPortfolio(""); // Limpia el input después de procesar el código
  };

  const containerStyle = {
    display: "flex",
    alignContent: "center",
    flexDirection: "row",
    paddingTop: "30px",
  };

  const calcularVariacionPortfolio = () => {
    let rendimientosPonderados = 0;
    let valorTotalPortfolioInicial = 0;

    // Calcular el valor total del portfolio inicial
    valorTotalPortfolioInicial = calcularValorTotal("ARS");

    // Calcular el rendimiento ponderado de cada acción y sumarlos
    acciones.forEach((accion) => {
      const stock = stocks.find((stock) => stock.ticker === accion.ticker);
      if (stock) {
        const rendimientoAccion =
          ((stock.actual_price - stock.price) / stock.price) * 100; // Calcular el rendimiento de la acción
        const ponderacionAccion =
          calcularPorcentaje(
            accion.cantidad,
            accion.ticker,
            valorTotalPortfolioInicial
          ) / 100; // Calcular la ponderación de la acción
        rendimientosPonderados += rendimientoAccion * ponderacionAccion; // Sumar el rendimiento ponderado de la acción al total
      }
    });

    return rendimientosPonderados.toFixed(2); // Devolver el rendimiento ponderado total del portfolio
  };

  return (
    <Box style={myStyle} sx={containerStyle}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "50%",
          marginLeft: "30px",
        }}
      >
        <Box>
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginRight: "50px",
                alignItems: "center",
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="ticker-label">Ticker de Acción</InputLabel>
                <Select
                  labelId="ticker-label"
                  id="ticker"
                  name="ticker"
                  value={formData.ticker}
                  onChange={handleChange}
                  sx={{ marginRight: "50px" }}
                >
                  {opciones.map((opcion, index) => (
                    <MenuItem
                      key={index}
                      value={opcion.ticker}
                    >{`${opcion.ticker} - ${opcion.nombre}`}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id="cantidad"
                name="cantidad"
                label="Cantidad"
                type="number"
                value={formData.cantidad}
                onChange={handleChange}
                sx={{ marginRight: "50px" }}
                inputProps={{ min: 1 }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                }}
              />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{ maxHeight: "40px", minWidth: "85px" }}
              >
                Agregar
              </Button>
            </Box>
          </form>
        </Box>
        <Box mt={2} sx={{ display: "flex", flexDirection: "column" }}>
          <ul>
            {acciones.map((accion, index) => (
              <li
                key={index}
                style={{ listStyle: "none", marginLeft: "-20px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "8px",
                  }}
                >
                  <Typography color={"#1a3b70"} sx={{ fontSize: "18px" }}>{`${accion.ticker
                    } - 
                  ${accion.cantidad} Cedear/s - 
                  USD: $${valorAccionUSD(
                      accion.ticker,
                      accion.cantidad
                    ).toLocaleString("es-ES", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })} - 
                  ${calcularPorcentaje(
                      accion.cantidad,
                      accion.ticker,
                      calcularValorTotal("ARS")
                    )}% del Portfolio`}</Typography>
                  <Button
                    variant="contained"
                    sx={{ maxHeight: "20px", marginLeft: "20px" }}
                    onClick={() => handleEliminarAccion(index)}
                  >
                    <Typography color={"white"}>Eliminar</Typography>
                  </Button>
                </Box>
              </li>
            ))}
          </ul>
          <Box
            sx={{ marginBottom: "10px", marginTop: "20px", display: "flex" }}
          >
            <Tooltip
              title={"Con este codigo podras recrear tu Portofolio en segundos"}
              placement="top"
              arrow
            >
              <Typography>{`Código:${generarCodigoIdentificador(
                acciones
              )}`}</Typography>
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", marginTop: "20px" }}
          >
            {/* Formulario para ingresar el código del portfolio */}
            <TextField
              id="codigoPortfolio"
              label="Código del Portfolio"
              value={codigoPortfolio}
              onChange={handleChangeCodigoPortfolio}
              sx={{ marginRight: "10px" }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmitCodigoPortfolio}
              sx={{ maxHeight: "40px", marginLeft: "10px" }}
            >
              Ingresar Código
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            height: "30px",
            display: "flex",
            flexDirection: "column",
            marginTop: "60px",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" color={"#1a3b70"}>
            Porfolios recomendados por Perfil del Inversor:
          </Typography>
          <Box
            sx={{
              height: "30px",
              display: "flex",
              flexDirection: "row",
              marginTop: "30px",
            }}
          >
            <Button
              variant="contained"
              onClick={() => handleOpen("Conservador")}
              sx={{ marginRight: "40px" }}
            >
              <Typography color={"white"}>Conservador</Typography>
            </Button>
            <Button
              variant="contained"
              onClick={() => handleOpen("Moderado")}
              sx={{ marginRight: "40px" }}
            >
              <Typography color={"white"}>Moderado</Typography>
            </Button>
            <Button
              variant="contained"
              onClick={() => handleOpen("Arriesgado")}
              sx={{ marginRight: "40px" }}
            >
              <Typography color={"white"}>Arriesgado</Typography>
            </Button>
          </Box>
        </Box>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              minWidth: "50vw",
              maxWidth: "90vw",
            }}
          >
            <PortfolioComponent perfil={perfilSeleccionado} />
            <Button onClick={handleClose}>Cerrar</Button>
          </Box>
        </Modal>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
          width: "50%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "15px",
          }}
        >
          <Tooltip
            title={`Valor en ARS: ${calcularValorTotal("ARS").toLocaleString(
              "es-ES",
              { minimumFractionDigits: 0, maximumFractionDigits: 0 }
            )}`}
            arrow
            placement="top"
          >
            <Typography variant="h6" color={"#1a3b70"}>
              Valor Portfolio USD: ${" "}
              {calcularValorTotal("USD").toLocaleString("es-ES", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                useGrouping: true,
              })}
            </Typography>
          </Tooltip>
          <Box sx={{ display: "flex" }}>
            <Typography
              variant="h6"
              color={"#1a3b70"}
              sx={{ marginRight: "5px" }}
            >
              Variación Cartera Hoy:{" "}
            </Typography>
            <Typography
              variant="h6"
              style={{
                color:
                  calcularVariacionPortfolio() > 0
                    ? "rgba(0, 255, 0, 0.5)"
                    : calcularVariacionPortfolio() < 0
                      ? "red"
                      : "white",
              }}
            >
              {calcularVariacionPortfolio()}%
            </Typography>
          </Box>
          <Typography variant="h6" color={"#1a3b70"}>
            PER Ponderado: {calculoPerCartera(acciones).toFixed(2)}
          </Typography>
          <Typography variant="h6" color={"#1a3b70"}>
            EV/FCF Ponderado: {calculoEVtoFCFCartera(acciones).toFixed(2)}
          </Typography>
          <Tooltip
            title={
              "Es el % que la cartera podria pagarte anualmente si distribuyera todos sus ingresos"
            }
            placement="bottom"
            arrow
          >
            <Typography variant="h6" color={"#1a3b70"}>
              FCF Yield:{" "}
              {(100 / calculoEVtoFCFCartera(acciones)).toLocaleString("es-ES", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              %
            </Typography>
          </Tooltip>
        </Box>
        <DonutChart2 Chartdata={chartData}></DonutChart2>
      </Box>
    </Box>
  );
};

export default MiPortfolio;
